import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { InactiveUserPopup } from "../InactiveUserPopup";
import { Route, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import TopHeader from "../components/TopHeader";
import { Navbar } from "../components/Navbar";
import PageFooter from "../components/PageFooter";
import TermsAndConditionsReacceptance from "../components/LegalDocumentPages/TermsAndConditionsReacceptance";
import * as Service from "../store/service";
import CommonContextProvider from "../CommonContextProvider";

interface IDefaultProps {
    component: any;
    path?: string;
    exact?: boolean;
    title?: string;
    canAccess?: boolean;
}

const RenderedComponent = (matchProps: any) => {
    let isCancelled = useRef(false);
    const [logoHTML, setLogoHTML] = useState("");
    const { component: Component, ...rest } = matchProps;
    let footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const showTopNav: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.navigationTop
            ? state.configurationState.configuration.partnerConfig.navigationTop
            : false
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : ""
    );
    let [isUserLoggedIn, setIsUserLoggedIn] = useState(null);

    useEffect(() => {
        isCancelled.current = true;
        Service.isUserAuthenticated().then((data) => {
            if (isCancelled.current) {
                setIsUserLoggedIn(data && data.isUserAuthenticated);
            }
        });

        return () => {
            isCancelled.current = false;
        };
    }, [isUserLoggedIn]);

    useEffect(() => {
        if (footerLogoHTML) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(footerLogoHTML, 'text/html');
            let imgElements = parsedDoc.querySelectorAll('img');
            imgElements?.forEach(img => {
                if (!img.hasAttribute('alt')) { 
                    img.setAttribute('alt', 'Logo');
                }
            });
            footerLogoHTML = parsedDoc.documentElement.innerHTML;
            setLogoHTML(footerLogoHTML);
        }
    }, []);

    const renderOnLoginSuccess = () => {
        return isUserLoggedIn ? (
            <div className="l-page-holder">
                <CommonContextProvider>
                    <InactiveUserPopup {...matchProps} />
                    <TopHeader {...matchProps} />
                    <main className={`${showTopNav ? "margin-top-neg" : ""}`} id="l-page-content">
                        <div className="l-page-container" id="title-page">
                            {!showTopNav && <Navbar />}
                            <div id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                                <Container>
                                    <Component {...rest} />
                                    <TermsAndConditionsReacceptance />
                                </Container>
                            </div>
                        </div>
                        <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoHTML }}></div>
                    </main>
                    {!renderSiteInIFrame && partnerId && <PageFooter />}
                </CommonContextProvider>
            </div>
        ) : (
            <Redirect to="/login" />
        );
    };

    return <React.Fragment>{isUserLoggedIn !== null ? renderOnLoginSuccess() : null}</React.Fragment>;
};

const Default = (props: IDefaultProps) => {
    const { component: Component, ...rest } = props;
    const canAccess = props.canAccess == null ? true : props.canAccess;
    return (
        <Route
            {...rest}
            render={(matchProps) => {
                return canAccess ? <RenderedComponent {...matchProps} component={Component} /> : <Redirect to="/dashboard" />;
            }}
        />
    );
};

export default Default;
